module.exports = __webpack_public_path__ + "static/img/sp-logo.93ac4928.svg";